import * as d3 from 'd3-selection'

export default function (series) {
  if (!series.length) {
    return
  }

  let el = d3.select(document.createElement('div'))
             .data([series])

  el.append('div')
    .attr('class', 'sb-chart-header sb-initiative-chart-header')
    .text(d => d[0].header)

  let row = el.append('table')
                .attr('class', 'sb-initiative-chart-tooltip')
                .append('tbody')
                  .attr('class', 'multi')
                  .selectAll('tr')
                  .data(d => d)
                  .enter()
                    .append('tr')
                    .select(function (d) {
                      let color = window.getComputedStyle(document.body)
                                        .getPropertyValue(`--palette-color-${d.color}`)
                      this.style.setProperty('--initiative-chart-row-color', color)
                      return this
                    })


  row.selectAll('td')
      .data(d => [d.text])
      .enter()
      .append('td')
      .text(String)

  return el.html()
}
